export enum StreamingProtocol {
  MpegDash = 'mpegDash',
  Hls = 'hls',
  None = 'none',
}